import controller from './profile.controller'
import template   from './profile.html'
import './profile.styl'

let component = {
  restrict: 'E',
  template,
  controller
}

export default component



// WEBPACK FOOTER //
// ./src/app/pages/profile/profile.component.js